import {Acceso} from '../_acceso/acceso';
export class Rol {
    id : number;
    nombre : string;
    estado : number;
    accesos : Acceso[] = [];    

    constructor(json? : any) {
        if (json != null) {
            this.id = json.id;
            this.nombre = json.nombre;
            this.estado = json.estado;

            if (json.accesos != null) {
                for (let acceso of json.accesos) {
                    this.accesos.push(new Acceso(acceso));
                }
            }            
        }
    }

    // Utils
    static toArray(jsons : any[]) : Rol[] {
        let rolList : Rol[] = [];
        if (jsons != null) {
            for (let json of jsons) {
                rolList.push(new Rol(json));
            }
        }
        return rolList;
    }
}



// WEBPACK FOOTER //
// ./src/app/_seguridad/_rol/rol.ts